
export function imageServerUrl({source, ratio, width, id, version, imgixSettings}) {
  if (source === "imgix") {
    const imgixBaseSettings = {
      w: width,
      h: _getImgHeight(width, ratio),
      fit: "crop",
      auto: "format",
      q: "45",
      cs: "tinysrgb"
  };
    const imgixMergedSettings = Object.assign({}, imgixBaseSettings, imgixSettings);
    const imgixParams = Object.keys(imgixMergedSettings).map(key => {
      return key + '=' + imgixMergedSettings[key];
      //return key + '64=' + btoa(imgixMergedSettings[key]).split("=").join("");
    }).join('&');

    return `http://quickshot.imgix.net/${id}?${imgixParams}`;
  }
  return `//www.svtstatic.se/image/${ratio}/${width}/${id}?v=${version}`;
}

function _getImgHeight(width, ratio){
  var height;
  if (ratio === "portrait") {
    height = width * (360/270);
  }
  else if (ratio === "square") {
    height = width * (200/200);
  }
  else if (ratio === "logo") {
    height = width * (70/125);
  }
  else if (ratio === "normal") {
    height = width * (270/360);
  }
  else if (ratio === "wide") {
    height = width * (126/224);
  }
  else if (ratio === "cinema") {
    height = width * (208/480);
  }
  else if (ratio === "imax") {
    height = width * (214/548);
  }
  else if (ratio === "balk") {
    height = width * (335/2000);
  }
  else if (ratio === "smalis") {
    height = width * (2400/1280);
  }

  else {
    height = width;
  }
  return Math.round(height);
}

export const preloadDefaultSize = '60vw';

export const noscriptPagewidth = 1024;

export const availableRatios = {
  portrait: {
    widths: [200, 400, 600, 800, 988, 1600]
  },
  square: {
    widths: [200, 400, 640, 750, 828, 988, 1600]
  },
  logo: {
    widths: [100]
  },
  normal: {
    widths: [100]
  },
  wide: {
    widths: [100, 200, 400, 640, 750, 828, 988, 1600]
  },
  cinema: {
    widths: [320, 400, 640, 750, 828, 988, 1280, 1600]
  },
  imax: {
    widths: [200, 400, 640, 750, 828, 988, 1600]
  },
  balk: {
    widths: [200, 400, 640, 750, 828, 988, 1600]
  },
  smalis: {
    widths: [200, 400, 640, 750, 828, 988, 1600]
  }
};

// FALLBACK STUFF
//const alternateImageNames = {
//  portrait: [
//    {name: 'medium_portrait', width: 270},
//    {name: 'large_portrait', width: 642}
//  ],
//  square: [
//    {name: 'square_small', width: 50},
//    {name: 'square', width: 200},
//    {name: 'square_large', width: 260}
//  ],
//  logo: [
//    {name: 'logo_extra_small', width: 125},
//    {name: 'logo_small', width: 153},
//    {name: 'logo', width: 215}
//  ],
//  normal: [
//    {name: 'medium_43', width: 360}
//  ],
//  wide: [
//    {name: 'small', width: 224},
//    {name: 'medium', width: 480},
//    {name: 'large', width: 650},
//    {name: 'extralarge', width: 992}
//  ],
//  cinema: [
//    {name: 'medium_cinema', width: 480},
//    {name: 'large_cinema', width: 760},
//    {name: 'extralarge_cinema', width: 980}
//  ],
//  imax: [
//    {name: 'medium_imax', width: 548},
//    {name: 'large_imax', width: 768},
//    {name: 'extralarge_imax', width: 1280}
//  ]
//};

//const playImageNames = {
//  portrait: [
//    {name: 'portrait_medium', width: 270},
//    {name: 'portrait_large', width: 642}
//  ],
//  square: [
//    {name: 'square', width: 200}
//  ],
//  normal: [
//    {name: '43_medium', width: 360}
//  ],
//  wide: [
//    {name: 'small', width: 224},
//    {name: 'medium', width: 480},
//    {name: 'large', width: 650},
//    {name: 'xlarge', width: 992}
//  ],
//  cinema: [
//    {name: 'cinema_medium', width: 480},
//    {name: 'cinema_large', width: 760},
//    {name: 'cinema_xlarge', width: 980}
//  ]
//};

//export function alternateImageServerUrl(alternateSrc, ratio, desiredWidth, isPlayPlaceholder) {
//  const images = isPlayPlaceholder ? playImageNames[ratio] : alternateImageNames[ratio];
//  var i = 0;
//  var width;
//  var imageName;
//  for (i; i < images.length; ++i) {
//    width = images[i].width;
//    if (width >= desiredWidth || i === (images.length - 1)) {
//      imageName = images[i].name;
//      break;
//    }
//  }
//  if (!imageName) {
//    imageName = images[0].name;
//  }
//  return alternateSrc.replace(/\{image_versions.name\}/, imageName);
//}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/pic.settings.js
 **/